import { updateVocabularyBookApi } from "@/api/services/admin/learning-content";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@/utils/toast";

type TUpdateVocabularyBookMemoParams = {
  vocabularyBookSpreadsheetUrl: string;
  vocabularyBookMemo: string;
};

/**
 * Hook to update vocabulary book memo on blur.
 * Requires spreadsheetUrl because the update API mandates it.
 */
export const useUpdateVocabularyBookMemo = (industryId?: string) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ vocabularyBookSpreadsheetUrl, vocabularyBookMemo }: TUpdateVocabularyBookMemoParams) => {
      if (!industryId) return Promise.reject(new Error("Missing industryId"));
      return updateVocabularyBookApi(industryId, {
        vocabularyBookSpreadsheetUrl,
        vocabularyBookMemo: vocabularyBookMemo || null,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_VOCABULARY_BOOK, industryId] });
      toast.success(API_SUCCESS_MESSAGE);
    },
    onError: (error) => {
      showError(error);
    },
  });

  return mutation;
};
